import { createRouter, createWebHistory } from "vue-router"
import Home from "@/views/Home.vue"
import Gallery from "@/views/Gallery"
import Contact from "@/views/Contact"
import Reservation from "@/views/Reservation"
import KurzKresby2026 from "@/views/KurzKresby2026"
import { SHOW_KURZ_KRESBY } from "@/config/features"

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Dvor u Maliara"
    }
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: "/galeria",
    name: "Gallery",
    component: Gallery
  },
  {
    path: "/kontakt",
    name: "Kontakt",
    component: Contact
  },
  {
    path: "/rezervacie",
    mane: "Rezervácie",
    component: Reservation
  },
  ...(SHOW_KURZ_KRESBY
    ? [{
      path: "/kurz-kresby-2026",
      name: "KurzKresby2026",
      component: KurzKresby2026,
      meta: {
        title: "Kurz kresby 2026 — Dvor u Maliara"
      }
    }]
    : [])
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior (to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  }
})

export default router
